import React from 'react'

export default function AboutSection({ title, description, features }) {
  return (
    <section
      id="about-us"
      className="main-section center-align"
      data-scroll-index="7"
    >
      <div className="container">
        {/*<!--Title-->*/}
        <h4 className="reflection-text p-b-2">{title}</h4>

        {/*<!-- Description -->*/}
        <p className="p-t-1 desc">{description}</p>

        <div className="row">
          {features.map(({ title, description, faIcon }) => (
            <div className="col s12 l4" key={title}>
              <div className="icon s6 p-tb-2">
                <i
                  className={`gradient-color fa fa-${faIcon} fa-3x waves-circle waves-effect waves-light`}
                />
              </div>
              <h5 className="p-tb-1">{title}</h5>
              <p>{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/AboutSection.js